// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#postmanify .sweet-modal .sweet-box-actions .sweet-action-close{display:flex;align-items:center;justify-content:center}#postmanify table{display:table}", ""]);
// Exports
module.exports = exports;
